//
//
//
//
//
//
//
//
//
//
//
//


export default {
  props: {
    text: {
      type: String,
      default: null
    },
    format: {
      type: String,
      default: 'plain'
    }
  },
  computed: {
    textLocal: function () {
      if (this.text && this.format === 'html' && process.env.VUE_APP_BACKEND_HREF) {
        let backendHref = process.env.VUE_APP_BACKEND_HREF
        if (backendHref.endsWith('/')) {
          backendHref = backendHref.substring(0, backendHref.length - 1)
        }
        return this.text.split(backendHref).join('')
      }
      return this.text || ''
    }
  },
  methods: {
    onTextClick: function (event) {
      if (event.target && event.target.href && !event.ctrlKey) {
        let href = event.target.href
        if (href.startsWith(window.location.origin)) {
          href = href.substring(window.location.origin.length)

          event.preventDefault()
          event.stopPropagation()

          // TODO проверить, что адрес корректный
          this.$router.push(href)

          // Скрываем активные диалоговые окна
          const dialogsEls = document.querySelectorAll('body > .q-dialog.q-dialog--modal')
          if (dialogsEls.length) {
            this.$nextTick(() => {
              for (const dialogEl of dialogsEls) {
                dialogEl.style.display = 'none'
              }

              const currentPath = this.$route.fullPath
              const unwatch = this.$watch('$route.fullPath', function (path) {
                if (path == currentPath) {
                  if (unwatch) {
                    unwatch()
                  }

                  // Восстанавливаем диалоговые окна
                  for (const dialogEl of dialogsEls) {
                    dialogEl.style.display = ''
                  }
                }
              })
            })
          }
        }
      }
    }
  }
}

